import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { ApiResult } from '../models/api/api-result.model';
import { ProjectStatusModel } from '../models/project/project-status.model';
import { Project } from '../models/project/Project.model';
import { ProjectDetailsModel } from '../models/project-info/ProjectDetails.model';
import { ProjectUpdateRequest } from '../models/project-info/ProjectUpdateRequest.model';
import { ApplicationGateway } from '../models/project/ApplicationGateway.model';
import { ProjectLocationData } from '../models/project/ProjectLocationData.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {



  constructor(private readonly apiService: ApiService) {
  }

    public GetProject(projectId:string|null): Observable<ApiResult<ProjectDetailsModel>> {

       return this.apiService.postnull<ProjectDetailsModel>('/project/'+projectId);
  }


  public GetApplication(applicationId:string|null): Observable<ApiResult<ApplicationGateway>> {

       return this.apiService.postnull<ApplicationGateway>('/gateway/'+applicationId);
  }


  public GetAllProjects(): Observable<ApiResult<Project[]>> {

       return this.apiService.postnull<Project[]>('/projects');
  }

  public GetProjectStatus(): Observable<ApiResult<ProjectStatusModel>> {

       return this.apiService.postnull<ProjectStatusModel>('/project-status');
  }
  
    public CreateProject(data: CreateProjectRequest): Observable<ApiResult<CreateProjectResponse>> {
     return this.apiService.post<CreateProjectResponse>( 'project/create', data);
  }


      public UpdateProject(data: ProjectUpdateRequest): Observable<ApiResult<boolean>> {
      return this.apiService.post<boolean>( '/project/update', data);
      }

     public DeleteProject(data: ProjectDetailsModel): Observable<ApiResult<boolean>> {
      return this.apiService.postnull<boolean>( '/project/delete/'+data.id);
      }

        public GetLocationFromIp(ip:string): Observable<ApiResult<ProjectLocationData>> {
               return this.apiService.postnull<ProjectLocationData>( '/location-ip/'+ip);
      }

}